import { render, staticRenderFns } from "./a-microcart-icon.vue?vue&type=template&id=07b9e3a9&scoped=true&"
import script from "./a-microcart-icon.vue?vue&type=script&lang=js&"
export * from "./a-microcart-icon.vue?vue&type=script&lang=js&"
import style0 from "./a-microcart-icon.vue?vue&type=style&index=0&id=07b9e3a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9e3a9",
  null
  
)

export default component.exports